class MetaPixel {
    trackCustom(event: string, data: Record<string, any>) {
        fbq('track', event, data);
    }
}

export default new MetaPixel();